import React from 'react';
import './Search.css';
import { Link, useParams, useHistory } from 'react-router-dom';

const Search = ({sData}) => {
 
    return (
        <div className = "search-product-component">
            {
                sData.map (data => 
                <ul style={{
                              textAlign: "left",
                              listStyle: "none",
                            }}>
                    <Link to={`/detail/:${data.id}`} style={{color: "white", textDecoration: "none"}}>
                    <li style={{
                              cursor: "pointer",
                            }}>{data.title.substring (0, 30)}</li>
                        </Link>
                </ul>)
            }
        </div>
    );
};

export default Search;